import React from 'react';
import { Badge, Icon } from '../ui';
import { moduleOf } from '../../theme/tokens';

// T0 — Badge de module (Environnement/Campagne/Performances/Transverse) à couleur cohérente.
export const ModuleBadge = ({ module, className = '' }) => {
  const m = moduleOf(module);
  return (
    <Badge color={m.color} className={className}>
      <Icon name={m.icon} className="h-3 w-3" />
      {m.label}
    </Badge>
  );
};

export default ModuleBadge;
